export default {
  name: 'patch',
  translationKey: 'patch-module',
  routePrefix: 'patch',
  routeNamePrefix: 'patch',
  directRoutesAvailable: true,
}
